import Authority from '../../Authority'
import { CoreAppointment } from './interfaces'

const VALID_STATUS = ['CREATED', 'PARTIAL_ASSIGNED']

export const acceptRejectCoreItemValidation = (a: CoreAppointment): boolean => {
  if (!Authority.hasPermission('appointment_item_request_acept_reject')) {
    return false
  }

  if (!VALID_STATUS.includes(a.appointmentStatus)) {
    return false
  }

  if (!a.hasItemsPending) {
    return false
  }
  return true
}
